import React, { useEffect } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import writtenNumber from "written-number";
import { capitalizeFirst } from "../../functions/Functions";
import { searchPropResiSales } from "../../../actions/propertyResiAction_Dwk";
import { closeModal } from "../../../actions/modalAction";
import { Form, Button } from "semantic-ui-react";
import NumberInput from "../../form/NumberInput";
import SelectInput from "../../form/SelectInput";
// import DateInput from "../../form/DateInput";

import {
  propresiStatus,
  propertyType,
  bedroom,
  bathroom,
  additionalRooms,
  furnishedStatus,
  floorNo,
  sorting,
} from "./Data";
import { projectNameResi, locality } from "../../functions/DataFunctions";

const PropResiSaleSearch = (props) => {
  useEffect(() => {
    const datePickers = document.getElementsByClassName(
      "react-datepicker__input-container"
    );
    Array.from(datePickers).forEach((el) =>
      el.childNodes[0].setAttribute("readOnly", true)
    );
  }, []);

  const { maxPrice, minPrice } =
    props.state.form &&
    props.state.form.PropResiSaleSearch !== undefined &&
    props.state.form.PropResiSaleSearch.values !== undefined &&
    props.state.form.PropResiSaleSearch.values;
  const { handleSubmit, reset, submitting } = props;

  const onSubmit = (values) => {
    const offsetRS = 0;
    const { limitRS } = props.state.dwk_resi_property;

    props.searchPropResiSales(values, limitRS, offsetRS);
  };

  return (
    <div
      className="font-family-Roboto"
      style={{ maxWidth: "700px", margin: "auto" }}
    >
      {/**/}
      <div
        className="card-attached border-radius-top "
        style={{ textAlign: "center", backgroundColor: "skyblue" }}
      >
        <div
          style={{
            fontSize: "1.3rem",
            fontWeight: "bold",
            padding: "10px",
          }}
        >
          {/*  */}
          Search Residential Property Available for Sale
          {/*  */}
        </div>
      </div>
      {/**/}

      {/*  */}

      <div className="card-attached border-radius-bottom pxy-20">
        <div className=" label">
          <Form onSubmit={handleSubmit(onSubmit)}>
            # Leave All Field Blank (Clear Values) to View All Available
            Properties
            <br />
            <br />
            <Button
              color="teal"
              type="button"
              onClick={() => props.closeModal()}
            >
              Cancel
            </Button>
            <Button
              color="orange"
              type="button"
              disabled={submitting}
              onClick={reset}
            >
              Clear Values
            </Button>
            <Button color="blue" type="submit" disabled={submitting}>
              Search
            </Button>
            <br />
            <br />
            <label>Sort By</label>
            <Field
              //search={true}
              name="sorting"
              type="text"
              component={SelectInput}
              options={sorting()}
              placeholder="Sort By"
            />
            <label>Property Type</label>
            <Field
              name="propertyTypeA"
              placeholder="Property Type"
              type="text"
              options={propertyType()}
              //search={true}
              multiple={true}
              component={SelectInput}
            />
            <label>Bedroom</label>
            <Field
              name="bedroomA"
              placeholder="Bedroom"
              type="text"
              options={bedroom()}
              //search={true}
              multiple={true}
              component={SelectInput}
            />
            <label>Bathroom</label>
            <Field
              name="bathroomA"
              placeholder="Bathroom"
              type="text"
              options={bathroom()}
              //search={true}
              multiple={true}
              component={SelectInput}
            />
            <label>Additional Rooms</label>
            <Field
              name="additionalRoomsA"
              placeholder="Additional Rooms"
              type="text"
              options={additionalRooms()}
              //search={true}
              multiple={true}
              component={SelectInput}
            />
            <label>Furnished Status</label>
            <Field
              name="furnishedStatusA"
              placeholder="Furnished Status"
              type="text"
              options={furnishedStatus()}
              //search={true}
              multiple={true}
              component={SelectInput}
            />
            <label>
              Minimum Price{" "}
              <span>
                (
                {minPrice &&
                  capitalizeFirst(
                    writtenNumber(minPrice, {
                      lang: "enIndian",
                    })
                  )}
                ){" "}
              </span>
            </label>
            <Field
              name="minPrice"
              placeholder="Minimum Price"
              type="number"
              component={NumberInput}
            />
            <label>
              Maximum Price{" "}
              <span>
                (
                {maxPrice &&
                  capitalizeFirst(
                    writtenNumber(maxPrice, {
                      lang: "enIndian",
                    })
                  )}
                ){" "}
              </span>
            </label>
            <Field
              name="maxPrice"
              placeholder="Maximum Price"
              type="number"
              component={NumberInput}
            />
            {/* <label>Entry</label>
            <Field
              name="entryA"
              placeholder="Entry"
              type="text"
              options={entry()}
              //search={true}
              multiple={true}
              component={SelectInput}
            />
            <label>Covered Car Parking</label>
            <Field
              name="carParkingCoveredA"
              placeholder="Covered Car Parking"
              type="text"
              options={carParkingCovered()}
              //search={true}
              multiple={true}
              component={SelectInput}
            />
            <label>Open Car Parking</label>
            <Field
              name="carParkingOpenA"
              placeholder="Open Car Parking"
              type="text"
              options={carParkingOpen()}
              //search={true}
              multiple={true}
              component={SelectInput}
            /> */}
            <label>Floor No</label>
            <Field
              name="floorNoA"
              placeholder="Floor No"
              type="text"
              options={floorNo()}
              search={true}
              multiple={true}
              component={SelectInput}
            />
            <label>Society/Apartment Name</label>
            <Field
              name="projectNameA"
              placeholder="Society/Apartment Name"
              type="text"
              options={projectNameResi(props.projectNameResis)}
              search={true}
              multiple={true}
              component={SelectInput}
            />
            <label>Locality</label>
            <Field
              name="localityA"
              placeholder="Locality"
              type="text"
              options={locality(props.localitys)}
              search={true}
              multiple={true}
              component={SelectInput}
            />
            {/* <label>Property Created FROM</label>
            <Field
              name="from"
              type="text"
              component={DateInput}
              dateFormat="dd-MM-yyyy"
              placeholder="Property Created FROM"
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
            />
            <label>Property Created TO</label>
            <Field
              name="to"
              type="text"
              component={DateInput}
              dateFormat="dd-MM-yyyy"
              placeholder="Property Created TO"
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
            />
             */}
             {props.userA !== null && props.userA.userType === 'admin' &&
             <>
             <label>Property Status</label>
             <Field
               //search={true}
               name="propresiStatus"
               type="text"
               component={SelectInput}
               options={propresiStatus()}
               placeholder="Property Status"
             />
             </>
             }
            <br />
            <Button color="blue" type="submit" disabled={submitting}>
              Search
            </Button>
            <Button
              color="orange"
              type="button"
              disabled={submitting}
              onClick={reset}
            >
              Clear Values
            </Button>
            <Button
              color="teal"
              type="button"
              onClick={() => props.closeModal()}
            >
              Cancel
            </Button>
          </Form>
          <br />
          <br />
          <br />
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    state,
    userA: state.auth.userA,
    projectNameResis: state.dwk_name.projectNameResis,
    localitys: state.dwk_name.localitys,
  };
};
export default connect(mapStateToProps, { searchPropResiSales, closeModal })(
  reduxForm({
    form: "PropResiSaleSearch", // a unique identifier for this form
    destroyOnUnmount: false,
    // validate
  })(PropResiSaleSearch)
);
